import React, { Component } from 'react'
import Item from './Item'
import { observer, inject } from 'mobx-react'
import isEmpty from 'lodash/isEmpty'

@inject('detailStore')
@observer
export default class extends Component {
  render() {
    const { orderDetail } = this.props.detailStore
    const { orderSub } = orderDetail
    return !isEmpty(orderSub) ? (
      <div style={{ flex: 1 }}>
        <Item />
      </div>
    ) : null
  }
}
